module.exports = __webpack_public_path__ + "static/media/Add.2174f65e.svg";